import { getApi, getApiPDF, postApi, putApi } from 'apis';

interface QueryParams {
	page: number;
	sortBy: string;
	sortOrder: string;
	pageSize: number;
	year: number;
}
interface UpdateMidMonth {
	id: string;
	status: string;
}
interface RegenerateCsv {
	id: string;
}

const getAllMidMonthPays = async (params: QueryParams) => {
	return await getApi('/mid-month-pay', params);
};

const updateMidMonthPayStatus = async (id: string, data: UpdateMidMonth) => {
	return await putApi(`/mid-month-pay/${id}`, data);
};

const regenerateCsv = async (body: RegenerateCsv) => {
	return await postApi(`/mid-month-pay/csv-re-generate`, body);
};

const getEmployeeDetailsForMidMonth = async (midMonthPayGroupId: string) => {
	return await postApi('/mid-month-pay/employee-details', {
		midMonthPayGroupId,
	});
};

const proceedToMidMonthPaymentForFCB = async (data: {
	midMonthPayGroupId: string;
	companyBankId: string;
}) => {
	return await postApi('/mid-month-pay/initiate-payment', data);
};

const getBankDetailsForMidMonthDetails = async (data?: { currency?: string; midMonthPayGroupId?: string }) => {
	return await postApi('/mid-month-pay/bank-details', data || {});
};

const getEmployeePaymentHistory = async (data: {
	midMonthId: string;
	employeeId: string;
}) => {
	return await getApi('/mid-month-pay/employee-payment-history', data);
};

const getPaymentLogs = async (data: { midMonthId: string }) => {
	return await getApi('/mid-month-pay/payment-logs', data);
};
const fetchMidMonthPayGroupData = async (data: { midMonthId: string }) => {
	return await postApi('/mid-month-pay/pay-group', data);
};
const exportMidMonthBank = async (
	midMonthPayId: string,
	payGroupId: string,
	bankType: string,
	fileType: string,
	paymentType: 'Cash' | 'Bank'
) => {
	return await getApiPDF('/mid-month-pay/export/bankfile', {
		midMonthPayId: midMonthPayId,
		payGroupId: payGroupId,
		bankType: bankType,
		fileType: fileType,
		paymentType: paymentType,
	});
};

export const midMonthPayApi = {
	getAllMidMonthPays,
	updateMidMonthPayStatus,
	regenerateCsv,
	getBankDetailsForMidMonthDetails,
	getEmployeeDetailsForMidMonth,
	proceedToMidMonthPaymentForFCB,
	getPaymentLogs,
	getEmployeePaymentHistory,
	fetchMidMonthPayGroupData,
	exportMidMonthBank,
};
